import { createGlobalStyle } from 'styled-components';

import { Tokens } from '../../types';

export const HTMLGlobalStyle = createGlobalStyle`
  body {
    font-family: ${Tokens.eixods.font.family.sans}, sans-serif;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${Tokens.eixods.colors.neutral.grey[0]};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${Tokens.eixods.colors.neutral.grey[40]};
    border-radius: 8px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${Tokens.eixods.colors.neutral.grey[100]};
    cursor: pointer;
  }
`;
